import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Testimonials from './Testimonials';
import Contact from './Contact';

const Home = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Header arka plan kontrolü için scroll state
  const [backgroundHeader, setBackgroundHeader] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const headerTextHeight = document.querySelector('.header-text')?.offsetHeight || 0;
      const headerHeight = document.querySelector('header')?.offsetHeight || 0;
      if (window.scrollY >= headerTextHeight - headerHeight) {
        setBackgroundHeader(true);
      } else {
        setBackgroundHeader(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Menu trigger toggle
  const toggleMenu = () => {
    const nav = document.querySelector('.header-area .nav');
    nav?.classList.toggle('active');
  };

  // Preloader state
  const [preloaderLoaded, setPreloaderLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setPreloaderLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  // Sayaçlar için state
  const [counts, setCounts] = useState({
    happyUsers: 0,
    memoriesStored: 0,
    eventsCreated: 0,
    yearsExperience: 0,
  });

  useEffect(() => {
    const targets = {
      happyUsers: 5000,
      memoriesStored: 250000,
      eventsCreated: 1500,
      yearsExperience: 3,
    };
    const increments = {
      happyUsers: Math.floor(targets.happyUsers / 100),
      memoriesStored: Math.floor(targets.memoriesStored / 100),
      eventsCreated: Math.floor(targets.eventsCreated / 100),
      yearsExperience: 1,
    };

    let frame;
    const updateCounts = () => {
      setCounts(prev => {
        const newCounts = { ...prev };
        let finished = true;

        for (const key in targets) {
          if (newCounts[key] < targets[key]) {
            newCounts[key] = Math.min(newCounts[key] + increments[key], targets[key]);
            finished = false;
          }
        }
        if (!finished) {
          frame = requestAnimationFrame(updateCounts);
        }
        return newCounts;
      });
    };
    frame = requestAnimationFrame(updateCounts);

    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <>
      {/* Preloader */}
      <div id="js-preloader" className={`js-preloader ${preloaderLoaded ? 'loaded' : ''}`}>
        <div className="preloader-inner">
          <span className="dot"></span>
          <div className="dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      {/* Header (header background toggle için class eklenebilir) */}
      <header className={backgroundHeader ? 'background-header' : ''}>
        <div className="menu-trigger" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        {/* Nav buraya eklenmeli */}
      </header>

      {/* Ana Banner */}
      <div className="main-banner" id="top">
        <div className="container">
          <Swiper
            modules={[Navigation, Pagination]}
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }}
            pagination={{ clickable: true }}
            loop={true}
            centeredSlides={true}
            spaceBetween={30}
            slidesPerView={1}
            className="swiper-banner"
          >
            <SwiperSlide>
              <div className="item item-1">
                <div className="header-text">
                  <span className="category">Anılarınız</span>
                  <h2>Anılarınız Bizimle Güvende ve Kolay Erişilebilir</h2>
                  <p>ANISAKLA ile özel anlarınızı güvenle saklayın, istediğiniz zaman erişin ve sevdiklerinizle kolayca paylaşın. Modern ve kullanıcı dostu arayüzümüz sayesinde anılarınızı yönetmek artık çok daha kolay.</p>
                  <div className="buttons">
                    <div className="main-button">
                      <a href="/login">Hemen Başla</a>
                    </div>
                    <div className="icon-button">
                      <a href="#services"><i className="fa fa-play"></i> Nasıl Çalışır?</a>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="item item-2">
                <div className="header-text">
                  <span className="category">Kolay Kullanım</span>
                  <h2>Anılarınızı Saklamanın En Kolay Yolu</h2>
                  <p>Kullanıcı dostu arayüzümüz sayesinde fotoğraflarınızı ve videolarınızı yüklemek, düzenlemek ve paylaşmak sadece birkaç tıklama uzağınızda. Teknik bilgi gerektirmeden anılarınızı kolayca yönetin.</p>
                  <div className="buttons">
                    <div className="main-button">
                      <a href="/login">Ücretsiz Deneyin</a>
                    </div>
                    <div className="icon-button">
                      <a href="#courses"><i className="fa fa-play"></i> Sık Sorulan Sorular</a>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="item item-3">
                <div className="header-text">
                  <span className="category">Güvenli Depolama</span>
                  <h2>Anılarınız Güvenle Bulutta Saklanır</h2>
                  <p>Tüm fotoğraflarınız ve videolarınız güvenli bulut sistemimizde saklanır. Cihazınız bozulsa bile anılarınız her zaman güvende kalır ve istediğiniz her yerden erişebilirsiniz.</p>
                  <div className="buttons">
                    <div className="main-button">
                      <a href="/login">Şimdi Başlayın</a>
                    </div>
                    <div className="icon-button">
                      <a href="#team"><i className="fa fa-play"></i> Kullanıcı Yorumları</a>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <div className="swiper-button-prev"><i className="fa fa-angle-left"></i></div>
            <div className="swiper-button-next"><i className="fa fa-angle-right"></i></div>
          </Swiper>
        </div>
      </div>

      {/* Hizmetler Bölümü */}
      <div className="services section" id="services">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="service-item">
                <div className="icon">
                  <img src="assets/images/service-01.png" alt="kolay yükleme" />
                </div>
                <div className="main-content">
                  <h4>Kolay Yükleme</h4>
                  <p>Fotoğraf ve videolarınızı sürükle-bırak yöntemiyle saniyeler içinde yükleyin ve düzenleyin.</p>
                  <div className="main-button">
                    <a href="#">Daha Fazla</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item">
                <div className="icon">
                  <img src="assets/images/service-02.png" alt="güvenli depolama" />
                </div>
                <div className="main-content">
                  <h4>Güvenli Depolama</h4>
                  <p>Anılarınız yüksek güvenlikli bulut sistemimizde şifrelenerek saklanır ve korunur.</p>
                  <div className="main-button">
                    <a href="#">Daha Fazla</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item">
                <div className="icon">
                  <img src="assets/images/service-03.png" alt="kolay paylaşım" />
                </div>
                <div className="main-content">
                  <h4>Kolay Paylaşım</h4>
                  <p>Anılarınızı sevdiklerinizle tek bir link üzerinden kolayca paylaşın ve birlikte hatırlayın.</p>
                  <div className="main-button">
                    <a href="#">Daha Fazla</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* İstatistikler Bölümü */}
      <div className="section fun-facts">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="counter">
                <h2 className="count-title count-number">{counts.happyUsers}</h2>
                <p className="count-text">Mutlu Kullanıcı</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="counter">
                <h2 className="count-title count-number">{counts.memoriesStored}</h2>
                <p className="count-text">Saklanan Anı</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="counter">
                <h2 className="count-title count-number">{counts.eventsCreated}</h2>
                <p className="count-text">Oluşturulan Etkinlik</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="counter">
                <h2 className="count-title count-number">{counts.yearsExperience}+</h2>
                <p className="count-text">Yıllık Deneyim</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Sık Sorulan Sorular */}
      <div className="section about-us" id="courses">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-1">
              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      ANISAKLA nasıl çalışır?
                    </button>
                  </h2>
                  <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      ANISAKLA, <strong>anılarınızı güvenle saklamanızı</strong> sağlayan bir bulut depolama hizmetidir. Hesabınızı oluşturduktan sonra fotoğraf ve videolarınızı yükleyebilir, düzenleyebilir ve sevdiklerinizle paylaşabilirsiniz. Tüm verileriniz güvenli sunucularımızda saklanır ve istediğiniz zaman erişebilirsiniz.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      Anılarım ne kadar güvende?
                    </button>
                  </h2>
                  <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      Tüm verileriniz <strong>yüksek güvenlikli bulut sistemimizde</strong> şifrelenerek saklanır. Sadece sizin ve izin verdiğiniz kişilerin erişimine açıktır. Düzenli yedeklemeler ve güvenlik önlemleri sayesinde anılarınız her zaman güvende kalır.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                      ANISAKLA neden en iyi seçenek?
                    </button>
                  </h2>
                  <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      ANISAKLA, kullanıcı dostu arayüzü, güvenli depolama sistemi ve kolay paylaşım özellikleriyle anılarınızı yönetmenin en kolay yolunu sunar. Ayrıca, özel etkinlikler oluşturarak misafirlerinizin de anılarınıza katkıda bulunmasını sağlayabilirsiniz.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingFour">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                      Teknik destek alabilir miyim?
                    </button>
                  </h2>
                  <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      Elbette! 7/24 müşteri destek ekibimiz her türlü sorunuzda size yardımcı olmak için hazır. İletişim sayfamızdan bize ulaşabilir veya <code>destek@anisakla.com.tr</code> adresine e-posta gönderebilirsiniz.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 align-self-center">
              <div className="section-heading">
                <h6>Hakkımızda</h6>
                <h2>Neden ANISAKLA'yı tercih etmelisiniz?</h2>
                <p>ANISAKLA, anılarınızı güvenle saklamanın ve paylaşmanın en kolay yolunu sunar. Kullanıcı dostu arayüzümüz, güvenli depolama sistemimiz ve özel paylaşım seçeneklerimizle anılarınız her zaman güvende ve elinizin altında.</p>
                <div className="main-button">
                  <a href="#">Daha Fazla Keşfet</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Kullanıcı Yorumları */}
      <Testimonials></Testimonials>

      {/* İletişim Bölümü */}
      <Contact></Contact>
    </>
  );
};

export default Home;
